"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _createStaticAssetUrl = require("./createStaticAssetUrl");
Object.keys(_createStaticAssetUrl).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _createStaticAssetUrl[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _createStaticAssetUrl[key];
    }
  });
});
var _parseTenantLanguageParams = require("./parseTenantLanguageParams");
Object.keys(_parseTenantLanguageParams).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _parseTenantLanguageParams[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _parseTenantLanguageParams[key];
    }
  });
});
var _parseUserSegmentationParams = require("./parseUserSegmentationParams");
Object.keys(_parseUserSegmentationParams).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _parseUserSegmentationParams[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _parseUserSegmentationParams[key];
    }
  });
});
var _reportWebVitals = require("./reportWebVitals");
Object.keys(_reportWebVitals).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _reportWebVitals[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _reportWebVitals[key];
    }
  });
});
